require("-!style!css!./../node_modules/vue-loader/lib/style-rewriter.js!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Carousel.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Carousel.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/template-rewriter.js!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Carousel.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Carousel.vue
 ** module id = 30
 ** module chunks = 0
 **/